import React from 'react'
import { downloadFile, imgProxy } from '../../utils/helpers'
import { Modal } from 'react-responsive-modal'
import { CertificateItemType } from '../AwardsEditBlock/types'

// Styles
import './styles.scss'

// Icons
import IconDownload from '../AwardsEditBlock/images/iconDownload'
import IconClose from '../ModalFiles/images/iconClose'

// Modal styles
const customModalStyles = {
  root: {
    zIndex: 99999,
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
  },
  modal: {
    width: 1186,
    maxWidth: 'unset',
    margin: '3em 0',
    borderRadius: 50,
    padding: '53px 82px 22px 72px',
    boxShadow: 'unset',
    overflow: 'unset',
    outline: 0,
    backgroundColor: '#FFF',
  },
}

const names = {
  certificate: 'Сертификат',
  gratitude: 'Благодарность',
  diploma: 'Диплом',
}

export default ({
  modal,
  close,
  certificates,
}: {
  modal: boolean
  close: () => void
  certificates: CertificateItemType[]
}) => {
  return (
    <Modal
      open={modal}
      styles={customModalStyles}
      onClose={close}
      showCloseIcon={false}
      center={true}
    >
      <div className={'modal-awards'}>
        <button className={'modal__close'} onClick={close}>
          <IconClose />
        </button>
        <div className={'modal-awards-title'}>Сертификаты и грамоты</div>
        <div className={'modal-awards-row'}>
          {certificates.map(item => (
            <div className={'item'} key={item.user_certificate_id}>
              <div className={'item__image'}>
                <img src={imgProxy(item.image.url, 450, 600)} />
              </div>
              <div className={'item__nav'}>
                <span>{names[item.certificate.type]}</span>
                <button
                  onClick={() => downloadFile(item.image.url, item.image.name)}
                >
                  <IconDownload />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}
